module.exports = __webpack_public_path__ + "static/media/download.54b8b93d.svg";